import React from "react";

import AuthImage from "@/react-components/AuthImage";

class CoverImage extends React.Component {
  render() {
    const { image, title, desc } = this.props;
    return (
      <div className="cover-image-container">
        <div>
          {title ? <div className="cover-image-title">{title}</div> : ""}
          {image?.src && <AuthImage src={image?.src} className="cover-image" />}
          {desc ? <div className="cover-image-desc">{desc}</div> : ""}
        </div>
      </div>
    );
  }
}

export default CoverImage;
